import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Logout({setCurrentUser}) {
    const navigate = useNavigate ();

    useEffect(() => {
        localStorage.removeItem('motus_access_token');
        localStorage.removeItem('motus_user_id');
        setCurrentUser(null);
        navigate('/');
    }, []); 

    return;
}